import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import config from 'SRC/config/config.yaml'
import Link from 'next/link'
import StpdBannerComponent from 'stpd-ad-component'
import { getFormattedAdPrice } from 'SRC/utils'
import { QuickSearch } from 'SRC/modules/categories/components'
import { getIsMobileDevice } from 'SRC/modules/common/selectors'
import { getCurrentAd, getIsServer, getIsMyAd } from '../../selectors'
import { HeadlineModel, HeadlinePrice, HeadlineBackUrl, HeadlineAdCode, HeadlineShowCounter } from '../Headline'
import { MainProps } from '../MainProps'
import { Equipment } from '../Equipment'
import { getPriceTypeTitle } from '../../functions'
import { Description } from '../Description'
import { RightColumn } from '../RightColumn'
import { RegistrationPriceMobile } from '../RegistrationPriceMobile'
import { LeftColumn } from '../LeftColumn'
import { Location } from '../Location'
import { SimilarAds } from '../Tab'
import { Agent } from '../Agent'
import { PhotosMobile } from '../PhotosMobile'
import { CallButton } from '../CallButton'

const getUserPhone = user => {
  const findUserPhone = user && Array.isArray(user.phones) && user.phones.length
    ? user.phones[0]
    : null

  return findUserPhone ? findUserPhone.phone : ''
}

export const Content = ({ ad, isServer, isMobileDevice, isMyAd }) => {
  const [windowWidth, setWindowWidth] = useState(0)

  useEffect(() => {
    setWindowWidth(window.innerWidth)
    const handleWindowResize = () => setWindowWidth(window.innerWidth)
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  React.useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 100)
  }, [ad.id])

  const mobileSlot = config.banners.adDetails.mobileTop

  const {
    seo,
    price,
    oldPrice,
    priceType,
    registrationCost,
    code,
    views,
    titleCompiled,
    category,
    description,
    country,
    city,
    location,
    closerLocation,
    priceFrom,
    priceTo,
    priceOnRequest,
    priceDaily,
    priceMonthly,
    agent,
    isBuying,
    user,
    status,
    activated
  } = ad

  const priceSpecification = category ? category.priceSpecification : null

  let title = titleCompiled || ''

  if (title.length > 58) {
    title = `${title.substring(0, 55)}...`
  }

  return (
    <div className='oglasi-content-oglas' style={{ border: 'none' }}>
      <div className='oglasi-headline'>
        {isMobileDevice ? <PhotosMobile /> : null}
        <div className='oglasi-headline-left'>
          <HeadlineModel title={title} />

          {status === 'Published' ? (
            <HeadlinePrice
              price={price}
              discount={oldPrice}
              priceType={getPriceTypeTitle(priceType)}
              priceFrom={priceFrom}
              priceTo={priceTo}
              priceOnRequest={priceOnRequest}
              priceDaily={priceDaily}
              priceMonthly={priceMonthly}
              priceSpecification={priceSpecification}
              isBuying={isBuying}
            />
          ) : null}
        </div>

        <div className='oglasi-headline-right'>
          {!isMobileDevice ? (
            <>
              <HeadlineAdCode code={code} />
              <HeadlineShowCounter count={Array.isArray(views) && views[0] ? views[0].count : 0} />
            </>
          ) : (
            <div className='oglasi-headline-ad-code-views'>
              <HeadlineAdCode code={code} />
              <HeadlineShowCounter count={Array.isArray(views) && views[0] ? views[0].count : 0} />
            </div>
          )}
        </div>

        {isMyAd && isMobileDevice
          ? (
            <Link href={{ pathname: 'editAd', query: { ad: seo } }} as={`/profil/oglasi/izmeni/${seo}`}>
              <a className='oglasi-edit-btn'>Izmijeni oglas</a>
            </Link>
          ) : null
        }
      </div>

      {isMobileDevice ? (
        <div style={{ textAlign: 'center', width: '100%' }}>
          <div style={{ width: windowWidth <= 727 ? 320 : 728, margin: 'auto' }}>
            <StpdBannerComponent
              refreshOnUrlChange={true}
              adUnitPath={`/${config.banners.dfpNetworkId}/${config.banners.adDetails.mobileTop.adUnit}`}
              size={config.banners.adDetails.mobileTop.sizes}
              divId={config.banners.adDetails.mobileTop.slotId}
            />
          </div>
        </div>
      ) : null}

      {category && category.specsShownWeb ? <MainProps /> : null}

      <div className='oglasi-info-and-img'>
        <LeftColumn />
        {!isMobileDevice ? <RightColumn isMyAd={isMyAd} /> : null}
        <Location
          country={country && country.name}
          city={city && city.name}
          location={location && location.name}
          closerLocation={closerLocation}
        />
        {isMobileDevice ? <RegistrationPriceMobile price={registrationCost ? getFormattedAdPrice(registrationCost) : 0} /> : null}
        <Equipment />
        <Description description={description} />
        {agent ? <Agent agent={agent} /> : null}

        {!isMobileDevice ? (
          <>
            <div className='oglasi-slicni-oglasi'>
              <div className='oglasi-info-heading'>
                <p>Slični oglasi</p>
              </div>

              <SimilarAds />
            </div>

            <QuickSearch page='ad' />
          </>
        ) : null}

        {isMobileDevice && status === 'Published' ? <CallButton phone={getUserPhone(user)} /> : null}
      </div>

      {/* {!isMobileDevice ? <Tab /> : null} */}
    </div>
  )
}

Content.propTypes = {
  ad: PropTypes.shape({
    category: PropTypes.shape({
      specsShownWeb: PropTypes.bool,
      pricePeriod: PropTypes.bool,
      priceSpecification: PropTypes.shape({
        value: PropTypes.string
      })
    }),
    price: PropTypes.number.isRequired,
    priceFrom: PropTypes.number,
    priceTo: PropTypes.number,
    discount: PropTypes.number,
    oldPrice: PropTypes.number,
    priceType: PropTypes.number.isRequired,
    priceOnRequest: PropTypes.bool,
    priceDaily: PropTypes.number,
    priceMonthly: PropTypes.number,
    code: PropTypes.string.isRequired,
    views: PropTypes.string.isRequired,
    titleCompiled: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    country: PropTypes.shape({
      name: PropTypes.string.isRequired
    }),
    city: PropTypes.shape({
      name: PropTypes.string.isRequired
    }),
    location: PropTypes.shape({
      name: PropTypes.string.isRequired
    }),
    closerLocation: PropTypes.string,
    agent: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      phone: PropTypes.string,
      email: PropTypes.string,
      image: PropTypes.string
    }),
    isBuying: PropTypes.bool
  }).isRequired,
  isServer: PropTypes.bool.isRequired,
  isMyAd: PropTypes.bool.isRequired,
  isMobileDevice: PropTypes.string.isRequired
}

Content.defaultProps = {
  isServer: true
}

const mapStateToProps = state => {
  const ad = getCurrentAd(state)

  return {
    ad,
    isMyAd: getIsMyAd(state),
    isServer: getIsServer(state),
    isMobileDevice: getIsMobileDevice(state)
  }
}

export default connect(mapStateToProps)(Content)
